import type React from 'react'

export const CloseButtonSvg = () => {
  return (
    <span className="block">
      <img src={`${process.env.NEXT_PUBLIC_SITEURL}/images/img_close_button.svg`} alt="" />
    </span>
  )
}
